// 头部导航
import React, {Component, PropTypes} from 'react';
import { Layout, Menu, Breadcrumb, Icon, BackTop, Dropdown, message } from 'antd';
import logout from '../../action/login/logout';
import {connect} from 'react-redux';
const { Header } = Layout;

class Top extends Component {
	static displayName = '头部导航';
	static propTypes = {
		user: PropTypes.object,
		logout: PropTypes.func,
	}

	constructor(props) {
		super(props);
	}

	doLogout = (e) => {
		e.preventDefault();
		this.props.logout().then(({retCode, retMsg}) => {
			if (retCode === 0) // 退出成功
			{
				message.success('退出成功', 1, function () {
					location.href = '/login/login.html?redirectUrl=' + location.pathname + location.search;
				});
			}
			else // 登录失败，弹出msg
			{
				message.error(retMsg, 1);
			}
		});
	}

	render() {
		const menu = (
				<Menu>
					<Menu.Item>
						<a href="javascript:void(0);" onClick={this.doLogout}><Icon type="logout"/> 退出</a>
					</Menu.Item>
				</Menu>
		);

		return (
				<Header className="header">
					<div className="logo" />
					<Menu
							theme="dark"
							mode="horizontal"
							defaultSelectedKeys={['2']}
							style={{ lineHeight: '64px', float : "right"}}
					>

						<Menu.Item key="3">
							<Dropdown overlay={menu} trigger={['click']}>
								<a className="ant-dropdown-link" href="#">
									{this.props.user.realName} <Icon type="down" />
								</a>
							</Dropdown>
						</Menu.Item>
					</Menu>


					<div>
						<BackTop />
					</div>
				</Header>
		);
	}
}

function mapStateToProps(state) {
	const {
		page: {
		}
	} = state;
	return {
	};
}

export default connect(mapStateToProps, {
	logout
})(Top);


// WEBPACK FOOTER //
// ./src/components/layout/top.js